import { UIComponentViewImpl } from '../uicomponentview';
import { UIComponentState } from '../uicomponent';
import { GridCSSStyle } from './gridcss';
import * as React from 'react';
import { GridComponentProps } from './gridcomponent';

export class GridViewImpl<T> extends UIComponentViewImpl<T>
{
    draw(props: GridComponentProps<T>, state: UIComponentState, cssStyle: GridCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return(
            <table style={cssStyle.getWrapperCSSStyle()}>
            {
                <>{props.listViewModel.getHeader()}</>} 
            <div style={{textAlign: "center", justifyContent: "center", width: "100%", height: "100%", display: "flex", flexFlow: "row wrap"}}>
            <tbody style={{textAlign: "center", justifyContent: "center", width: "100%", height: "100%", display: "flex", flexFlow: "row wrap"}}>
                {
                    props.listViewModel.getListOfDatas().map((entry, index)=>
                    {
                        return <>{props.listViewModel.getView(entry, index)}</>;
                    }
                )
                }
            </tbody>
            </div>
            </table>
       );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/grid/gridview.tsx